module.exports = __webpack_public_path__ + "img/nodeType5.c70cb884.svg";